<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  /**
   * @typedef {Object} Props
   * @property {number} [size=20] The width and height dimension for the icon
   * @property {string} [fill="#000000"] The color to fill the icon
   */

  /** @type {Props} */
  let { size = 20, fill = "#000000" } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-label="Chevron down icon"
>
  <path
    d="M19.8644 5.22892C19.9572 5.35257 20 5.49077 20 5.64351C20 5.79625 19.9572 5.9199 19.8644 6.01446L10.4069 15.6955C10.2855 15.79 10.1499 15.8337 10 15.8337C9.85011 15.8337 9.72876 15.79 9.63597 15.6955L0.135617 6.01446C0.0428265 5.9199 0 5.79625 0 5.64351C0 5.49077 0.0428265 5.35257 0.135617 5.22892L1.04211 4.30519C1.12777 4.21063 1.24911 4.16699 1.40614 4.16699C1.56317 4.16699 1.69165 4.21063 1.81299 4.30519L10.0071 12.6551L18.1941 4.30519C18.3155 4.21063 18.4511 4.16699 18.601 4.16699C18.7509 4.16699 18.8722 4.21063 18.965 4.30519L19.8644 5.22892Z"
    {fill}
  />
</svg>
